import { createContext, useContext, useEffect, useState } from 'react';
import { authApi } from '@/lib/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('wellth_token');
    if (!token) { setLoading(false); return; }
    authApi.me().then(setUser).catch(() => {
      localStorage.removeItem('wellth_token');
    }).finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { token, user } = await authApi.login({ email, password });
    localStorage.setItem('wellth_token', token);
    setUser(user);
    return user;
  };

  const register = async (name, email, password) => {
    const { token, user } = await authApi.register({ name, email, password });
    localStorage.setItem('wellth_token', token);
    setUser(user);
    return user;
  };

  const googleLogin = async (sessionId) => {
    const { token, user } = await authApi.google(sessionId);
    localStorage.setItem('wellth_token', token);
    setUser(user);
    return user;
  };

  const logout = () => {
    localStorage.removeItem('wellth_token');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, googleLogin, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
